/* YourChristmasTree help center. Loaded by sections/help-bot.liquid. Opens from any [data-bot-open] element.
   Built on the Dore & Rose accordion pattern: .accordion__wrapper > button.accordion__title + .accordion__body */
(function () {
  'use strict';
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var html = document.documentElement;
  var HELP = null;
  var STOP = 'a an the is it its do does did i im my me you your can could will would what whats how where which who to for of on in and or with this that be are am there if so any about got have has just please'.split(' ');

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9\s']/g, ' ').replace(/\s+/g, ' ').trim(); }
  function desktop() { return window.matchMedia('(min-width: 750px)').matches; }

  function init() {
    var root = document.getElementById('SLBot');
    if (!root) { html.classList.remove('has-bot'); HELP = null; return; }
    html.classList.add('has-bot');
    var title = $('[data-help-title]', root), back = $('[data-help-back]', root), search = $('[data-help-search]', root);
    var body = $('[data-help-body]', root), empty = $('[data-help-empty]', root);
    var views = $$('[data-help-view]', root), items = $$('[data-help-item]', root);
    var homeTitle = title.textContent, current = 'home', lastFocus = null, timer = null, autoOpen = null;
    var shopUrl = root.getAttribute('data-shop-url') || '/collections/all';

    function show(name) {
      current = name;
      if (autoOpen) { toggle(autoOpen, false); autoOpen = null; }
      root.classList.remove('is-searching');
      items.forEach(function (it) { it.hidden = false; });
      if (empty) empty.hidden = true;
      views.forEach(function (v) { v.hidden = v.getAttribute('data-help-view') !== name; });
      back.hidden = name === 'home';
      var v = root.querySelector('[data-help-view="' + name + '"]');
      title.textContent = name === 'home' ? homeTitle : (v && v.getAttribute('data-help-name')) || homeTitle;
      body.scrollTop = 0;
    }

    /* Accordions, Dore & Rose style */
    function toggle(item, open) {
      var btn = $('.accordion__title', item), panel = $('.accordion__body', item);
      var on = open === undefined ? btn.getAttribute('aria-expanded') !== 'true' : open;
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      panel.hidden = !on;
      item.classList.toggle('is-open', on);
      if (on) fillLive(item);
    }
    function fillLive(item) {
      var live = $('[data-help-live]', item);
      if (!live) return;
      var vis = function (d) { return !d.hidden; };
      var sel = '[data-delivery], [data-ship-line]';
      var el = $$('.product__info ' + sel.replace(', ', ', .product__info ')).filter(vis)[0] || $$('main ' + sel.replace(', ', ', main ')).filter(vis)[0] || $$(sel).filter(vis)[0];
      var span = el && $$('[data-delivery-ok], [data-delivery-late]', el).filter(vis)[0];
      var txt = el ? (span || el).textContent.replace(/\s+/g, ' ').trim() : '';
      live.textContent = txt ? txt + '.' : '';
      live.hidden = !txt;
    }

    /* Search: filters every answer as you type */
    function score(it, words, q) {
      if (!it.__q) {
        it.__q = ' ' + norm(it.getAttribute('data-q') + ' ' + (it.getAttribute('data-k') || '').replace(/,/g, ' ')) + ' ';
        it.__all = it.__q + norm($('.accordion__body', it).textContent);
      }
      var s = 0;
      if (q.length > 3 && it.__q.indexOf(q) > -1) s += 6;
      words.forEach(function (w) {
        if (it.__q.indexOf(' ' + w + ' ') > -1) s += 3;
        else if (w.length > 2 && it.__q.indexOf(' ' + w) > -1) s += 2;
        else if (w.length > 3 && it.__all.indexOf(w) > -1) s += 1;
      });
      return s;
    }
    function runSearch() {
      var q = norm(search.value);
      if (!q) { show(current === 'search' ? 'home' : current); return; }
      if (current !== 'search') current = 'search';
      root.classList.add('is-searching');
      var words = q.split(' ').filter(function (w) { return w && STOP.indexOf(w) < 0; });
      if (!words.length) words = q.split(' ');
      var need = words.length > 1 ? 3 : 2, any = false, best = null, bestS = 0, tie = false;
      views.forEach(function (v) {
        if (v.getAttribute('data-help-view') === 'home') { v.hidden = true; return; }
        var hits = 0;
        $$('[data-help-item]', v).forEach(function (it) {
          var s = score(it, words, q), ok = s >= need;
          it.hidden = !ok;
          if (ok) {
            hits++;
            if (s > bestS) { best = it; bestS = s; tie = false; } else if (s === bestS) tie = true;
          }
        });
        v.hidden = !hits;
        if (hits) any = true;
      });
      /* Open the clear winner so the answer is already there, one less tap */
      var pick = best && (!tie || q.length > 3) ? best : null;
      if (autoOpen && autoOpen !== pick) toggle(autoOpen, false);
      if (pick && pick !== autoOpen) toggle(pick, true);
      autoOpen = pick;
      if (empty) {
        empty.hidden = any;
        var mail = $('[data-help-mail]', empty);
        if (mail) mail.href = mail.href.split('?')[0] + '?subject=' + encodeURIComponent('Question') + '&body=' + encodeURIComponent(search.value);
      }
      back.hidden = false;
      title.textContent = 'Search';
      body.scrollTop = 0;
    }
    function clearSearch() { if (search.value) search.value = ''; }

    /* Height finder: the only place a shopper types, in numbers */
    var finder = $('[data-hfind]', root), unit = 'ft';
    function parseFt(str) {
      var t = String(str).toLowerCase().replace(',', '.');
      var m = t.match(/(\d+(?:\.\d+)?)\s*(ft|feet|foot|'|’|′|cm)?/);
      if (!m) return 0;
      var n = parseFloat(m[1]);
      if (m[2] === 'cm') return n / 30.48;
      var rest = t.slice(m.index + m[0].length).match(/^\s*(\d{1,2})\s*(in|inch|")?/);
      if (m[2] && m[2] !== 'cm' && rest) n += parseFloat(rest[1]) / 12;
      return n;
    }
    function pageHeights() {
      var out = [];
      $$('[data-option]').forEach(function (f) {
        var lab = (f.querySelector('legend') || {}).textContent || '';
        if (!/height|size/i.test(lab)) return;
        $$('input[type="radio"]', f).forEach(function (i) {
          if (!/(ft|feet|foot|'|’|′|cm)/i.test(i.value)) return;
          var v = parseFt(i.value); if (v >= 2 && v <= 20) out.push({ ft: v, label: i.value, input: i });
        });
      });
      return out;
    }
    function fmt(n) { return (Math.round(n * 2) / 2).toString(); }
    function compute() {
      if (!finder) return;
      var input = $('[data-hfind-input]', finder), res = $('[data-hfind-result]', finder);
      var v = parseFloat(String(input.value).replace(',', '.'));
      if (!v) { res.hidden = true; res.innerHTML = ''; return; }
      var ceil = unit === 'cm' ? v / 30.48 : v;
      if (unit === 'ft' && v > 40) ceil = v / 30.48;
      res.hidden = false;
      if (ceil < 5 || ceil > 30) { res.innerHTML = '<p>Enter your ceiling height, for example <strong>8</strong> ft or <strong>244</strong> cm.</p>'; return; }
      var hs = pageHeights();
      var list = (hs.length ? hs : [6, 6.5, 7, 7.5, 8, 9, 10, 12].map(function (f) { return { ft: f, label: f + ' ft' }; }))
        .sort(function (a, b) { return b.ft - a.ft; });
      var fit = list.filter(function (h) { return h.ft <= ceil - 0.5; });
      if (!fit.length) {
        res.innerHTML = '<p class="hfind__fit">It gets tight</p><p>Our smallest tree is <strong>' + list[list.length - 1].label + '</strong>. That leaves less than 6 inches for a topper. Email us a photo of the spot and we tell you honestly if it fits.</p>';
        return;
      }
      var best = fit[0], alt = fit[1], gap = Math.round((ceil - best.ft) * 12);
      var h = '<p class="hfind__fit"><strong>' + best.label + '</strong> fits best</p>' +
        '<p>About ' + gap + ' inches left above the tip for a topper on ' + (/^(8|11|18)(\.|$)/.test(fmt(ceil)) ? 'an ' : 'a ') + fmt(ceil) + ' ft ceiling.' + (alt ? ' Want room for a big star? The ' + alt.label + ' works too.' : '') + '</p><div class="help__acts">';
      if (best.input) {
        h += '<button type="button" class="btn btn--primary btn--sm" data-hfind-pick="0">Select ' + best.label + '</button>';
        if (alt && alt.input) h += '<button type="button" class="btn btn--outline btn--sm" data-hfind-pick="1">Select ' + alt.label + '</button>';
      } else {
        h += '<a class="btn btn--primary btn--sm" href="' + shopUrl + '">Shop ' + best.label + ' trees</a>';
      }
      res.innerHTML = h + '</div>';
      res.__fit = fit;
    }
    function setUnit(u) {
      unit = u;
      $$('[data-hfind-unit]', finder).forEach(function (b) { var on = b.getAttribute('data-hfind-unit') === u; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var input = $('[data-hfind-input]', finder); input.placeholder = u === 'cm' ? '244' : '8';
      compute();
    }
    function openFinder() {
      var item = $('[data-help-height-item]', root);
      if (!item) return;
      clearSearch();
      show(item.closest('[data-help-view]').getAttribute('data-help-view'));
      toggle(item, true);
      if (desktop()) setTimeout(function () { var i = $('[data-hfind-input]', item); if (i) i.focus(); }, 340);
    }
    if (finder) {
      $('[data-hfind-input]', finder).addEventListener('input', compute);
    }

    /* Open and close */
    function open(ask, focus) {
      lastFocus = document.activeElement;
      root.hidden = false;
      html.classList.add('bot-lock');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      clearSearch();
      var item = null;
      if (ask) {
        var a = norm(ask);
        item = items.filter(function (it) { return norm(it.getAttribute('data-q')) === a; })[0];
      }
      if (item) {
        show(item.closest('[data-help-view]').getAttribute('data-help-view'));
        toggle(item, true);
        if (item.hasAttribute('data-help-height-item') && desktop()) setTimeout(function () { var i = $('[data-hfind-input]', item); if (i) i.focus(); }, 340);
      } else if (ask) {
        search.value = ask; runSearch();
      } else {
        show('home');
        if (focus && desktop()) setTimeout(function () { search.focus(); }, 340);
      }
    }
    function close() {
      root.classList.remove('is-open');
      html.classList.remove('bot-lock');
      setTimeout(function () { root.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-bot-close]'))) { close(); return; }
      if ((t = e.target.closest('.accordion__title'))) { toggle(t.closest('[data-help-item]')); return; }
      if ((t = e.target.closest('[data-help-open]'))) { clearSearch(); show(t.getAttribute('data-help-open')); return; }
      if (e.target.closest('[data-help-height]')) { openFinder(); return; }
      if (e.target.closest('[data-help-back]')) { clearSearch(); show('home'); return; }
      if ((t = e.target.closest('[data-hfind-unit]'))) { setUnit(t.getAttribute('data-hfind-unit')); return; }
      if ((t = e.target.closest('[data-hfind-chip]'))) { setUnit('ft'); $('[data-hfind-input]', finder).value = t.getAttribute('data-hfind-chip'); compute(); return; }
      if ((t = e.target.closest('[data-hfind-pick]'))) {
        var res = $('[data-hfind-result]', finder), pick = res.__fit && res.__fit[+t.getAttribute('data-hfind-pick')];
        if (pick && pick.input) {
          pick.input.checked = true;
          pick.input.dispatchEvent(new Event('change', { bubbles: true }));
          t.textContent = pick.label + ' selected';
          t.disabled = true;
          setTimeout(close, 650);
        }
      }
    });
    search.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(runSearch, 90); });
    search.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); search.blur(); } });

    HELP = { open: open, close: close, root: root };
  }

  window.SLBotInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && HELP && !HELP.root.hidden) HELP.close(); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bot-open]');
    if (!t || !HELP) return;
    e.preventDefault();
    HELP.open(t.getAttribute('data-bot-ask') || '', t.hasAttribute('data-bot-focus'));
  });
})();
